<template>
  <div class="material-category__item">
      <div class='user-info' >
        <el-radio-group v-model="active_radio" @change="handleChangeCategory">
          <el-radio-button :label="0"><span class="title-span">全部</span></el-radio-button>
          <el-radio-button :label="str.id" v-for="(str,index) in formData" :key="index"><span class="list-span" @click="handleSelectCategory(str,index)">{{str.name}}</span></el-radio-button>
        </el-radio-group>
      </div>
      <ul v-if="isOpen"  class="info-left">
        <tree-item :formData="formData[childrenIndex].children" :treeProps="treeProps" ></tree-item>
      </ul>
  </div>
</template>

<script>
export default {
  name: 'TreeItem', //递归组件必须有name
  props:['formData','treeProps',],
  data() {
    return {
      isOpen: false,
      childrenIndex:0,
      active_radio:0,
      parent_id:null,
      data:[]
    }
  },
  watch:{
    formData(){
      this.active_radio = 0
    }
  },
  methods: {
    // 点击类别
    handleChangeCategory(value){
      if (this.active_radio === 0) {
        this.isOpen = false
        this.$Bus.$emit('form—children',this.parent_id)
      } else {
        this.data.length !== 0 ? this.isOpen = true:''
        this.$Bus.$emit('form—children',this.active_radio)
      }
    },
    // 选择单个分类
    handleSelectCategory(data, index) {
      this.active_radio = 0
      this.parent_id = data.parent_id
      if (this.isOpen) {
        this.isOpen = false
        this.data = data.children
      } else this.isOpen = data.children.length > 0
      this.childrenIndex = index
    }
  }

}
</script>

<style lang='less'>
    .material-category__item{
        .user-info{
            border-bottom: 1PX solid #F4F4F4;
            margin-top: 10px;
            .el-radio-button__orig-radio:checked+.el-radio-button__inner{
                border: none;
                background-color: transparent;
                box-shadow: none;
                span{
                    background-color: #FFDE00;
                    color: #fff !important;
                    border-radius: 4px;
                    padding: 2px 5px;
                }
            }
            .el-radio-button__inner{
                background-color: transparent;
                padding: 0;
                border: 0;
            }
            .el-radio-button:first-child .el-radio-button__inner{
                border: 0;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/material/item.vue